<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('TITLE')">
        <inputvalidation :formerror="formError" name="title">
          <b-form-input type="text" v-model="formData.title"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('CATEGORY')">
        <b-form-select :options="categories.root" v-model="formData.categoryId" value-field="categoryId" text-field="name"></b-form-select>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('DESCRIPTION')">
        <textarea class="form-control" v-model="formData.description" rows="3" v-bind:placeholder="$t('DESCRIPTION')"></textarea>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-9">
      <b-form-fieldset v-bind:label="$t('SELECTFILE')">
        <fileupload v-model="formData.file" :chooseLabel="$t('SELECTFILE')" />
      </b-form-fieldset>
    </div>
    <div class="col-sm-3">
      <button type="button" class="btn btn-add" style="margin-top:80px;" @click="selectPreviousDocument()">
          <!-- icon icon="plus"></icon --> {{$t('SELECTPREVIOUSDOCUMENT')}}
        </button>
    </div>
  </div>
</div>
</template>

<script>
export default
{
  name: 'Documents',
  props: ['formData', 'formError', 'categories', 'selectPreviousDocument'],
  data: function()
  {
    return {

    }
  },
  created()
  {
    var me = this;
  },
  methods:
  {

  },
  computed:
  {

  }
}
</script>
